const IO_DEVICE_LABELS: Record<string, string> = {
    dmp: "DMP Panel",
    pz25x: "PZ-25X",
    pz520relay: "PZ-520 Relay",
    pz551wirelessreceiver: "PZ-551 Wireless Receiver",
};

export function humanizeDeviceType(type: string): string {
    return IO_DEVICE_LABELS[type] ?? (type.charAt(0).toUpperCase() + type.slice(1));
}

export function formatIoDeviceKey(key: string): string {
    const [, type = "", identifier] = key.split(":");
    const label = humanizeDeviceType(type);
    return identifier ? `${label}:${identifier}` : label;
}
